import { httpClientPrivate } from '@/libs/httpClient'
import { useQuery } from '@tanstack/react-query'
import api from '@/constant/END_POINT'

const fetchRejectDocument = async (claimFormId: string) => {
  const response = await httpClientPrivate.get<string>(api.backoffice.rejectDocument(claimFormId))

  return response.data
}

const useRejectDocument = (claimFormId: string) => {
  const queryKey = ['useRejectDocument', claimFormId]
  const queryFn = async () => fetchRejectDocument(claimFormId)
  const queryResult = useQuery({ queryKey, queryFn })

  return { ...queryResult }
}

export { fetchRejectDocument, useRejectDocument }
